import {
  GET_CONSENT,
  POST_ENTER_CALL,
  POST_MESSAGES,
  SET_CONSENT,
  SET_PARTICIPANTS,
} from "../actions/call";

const INITIAL_STATE = {
  call: {
    data: {},
    loading: false,
    error: false,
  },
  consent: {
    data: null,
    loading: false,
    error: false,
  },
  participants: {
    data: [],
  },
};

const call = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${POST_ENTER_CALL}_REJECTED`:
      return {
        ...state,
        call: {
          ...state.call,
          loading: false,
          error: true,
          data: action.payload?.data,
        },
      };

    case `${POST_ENTER_CALL}_PENDING`:
      return {
        ...state,
        call: {
          ...state.call,
          loading: true,
          error: false,
        },
      };

    case `${POST_ENTER_CALL}_FULFILLED`:
      return {
        ...state,
        call: {
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case `${GET_CONSENT}_PENDING`:
      return {
        ...state,
        consent: {
          ...state.consent,
          loading: true,
          error: false,
        },
      };

    case `${GET_CONSENT}_FULFILLED`:
      return {
        ...state,
        consent: {
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case `${GET_CONSENT}_REJECTED`:
      return {
        ...state,
        consent: {
          ...state.consent,
          loading: false,
          error: true,
        },
      };

    case `${SET_CONSENT}_FULFILLED`:
      return {
        ...state,
        consent: {
          ...state.consent,
          loading: false,
          error: false,
          data: state.consent.data
            ? {
              ...state.consent.data,
              consentimiento: action.meta?.consentAccepted,
            }
            : state.consent.data,
        },
      };

    case `${SET_CONSENT}_PENDING`:
      return {
        ...state,
        consent: {
          ...state.consent,
          loading: true,
          error: false,
        },
      };

    case `${SET_CONSENT}_REJECTED`:
      return {
        ...state,
        consent: {
          ...state.consent,
          loading: false,
          error: true,
        },
      };

    case `${POST_MESSAGES}_REJECTED`:
      return {
        ...state,
        postMessages: {
          ...state.postMessages,
          loading: false,
          error: true,
          data: action.payload?.data,
        },
      };

    case `${POST_MESSAGES}_PENDING`:
      return {
        ...state,
        postMessages: {
          ...state.postMessages,
          loading: true,
          error: false,
        },
      };

    case `${POST_MESSAGES}_FULFILLED`:
      return {
        ...state,
        postMessages: {
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case SET_PARTICIPANTS:
      return {
        ...state,
        participants: {
          ...state.participants,
          data: action.payload,
        },
      };

    default:
      return state;
  }
};

export default call;
